import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import './styles/css/common.css'
import './styles/demo/Demos.scss'
import './styles/layout/layout.scss'
import AppWrapper from './component/layout/AppWrapper'
import { RdmsMenuContextProvider } from './component/menu/context/rdmsMenuContext'
import { CommonProvider } from './component/common/context/commonContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <HashRouter>
            <CommonProvider>
                <RdmsMenuContextProvider>
                    <AppWrapper />
                </RdmsMenuContextProvider>
            </CommonProvider>
        </HashRouter>
    </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
